import { BookingAlertManager } from "components/alerts/booking-alert-manager";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { PaymentRule } from "types/payment";
import { isNoShowBooking, isWaitList } from "utils/booking";

interface InfromationAlertSectionProps {
    shouldShowConfirmWaitListBtn: boolean;
    isBookingCanceled: boolean;
}

const MyBookingAlert = ({
    shouldShowConfirmWaitListBtn,
    isBookingCanceled,
}: InfromationAlertSectionProps) => {
    const { data: booking } = useWebBooking();

    if (!booking) {
        return null;
    }

    const isNoShow = isNoShowBooking(booking);
    const isWaitListBooking = isWaitList(booking);

    const rule = booking.webBookingRules?.at(0);
    const isPrePayment = rule?.paymentRule === PaymentRule.Prepayment;
    const isNoShowFee = rule?.paymentRule === PaymentRule.NoShowFee;

    const lastPaymentEvent = booking.paymentEvents?.at(-1);
    const hasNoShowCharge = (lastPaymentEvent?.payedAmount ?? 0) > 0 && isNoShow;

    return (
        <BookingAlertManager
            isNoShow={isNoShowFee}
            isPrepayment={isPrePayment}
            isWaitList={isWaitListBooking}
            hasNoShowCharge={hasNoShowCharge}
            isBookingCanceled={isBookingCanceled}
            shouldShowConfirmWaitListBtn={shouldShowConfirmWaitListBtn}
        />
    );
};

export default MyBookingAlert;
